import Article, {
  ArticleContentBox,
  DisclaimerBox,
  DisclaimerText,
  DisclaimerTitle,
} from '../../shared_components/Library/Article'
import { H3, P, Strong } from '../../shared_components/Library/Typeography'
import { Box } from '../../shared_components/UI/Box'
import { ThemedAnchor, ThemedLink } from '../../shared_components/ThemedButton'
import routes from '../../router/routes'
import Gift01 from '../../shared_components/Icons/Gift01'
import Lock01 from '../../shared_components/Icons/Lock01'
import UserUp02 from '../../shared_components/Icons/UserUp02'

const ZapDropsArticle = () => {
  return (
    <Article
      bannerUrl="/how-it-works-drops-banner.png"
      title="Meet ZAP Drops. The fair way to get rewarded for your contributions "
      content={
        <>
          <ArticleContentBox>
            <H3 fw="semibold">Why ZAP Drops?</H3>
            <P c="text-secondary">
              <Strong>Verified rewards.</Strong> Rewards on ZAP Drops are locked
              for the community. Before you complete missions you know the prize
              pool - 100% of this will be distributed to participants
            </P>
            <P c="text-secondary">
              <Strong>Fair distribution.</Strong>
              Rewards are distributed according to our level-based system. The
              higher the level, the more you’ll earn.
            </P>
            <P c="text-secondary">
              <Strong>No more bots.</Strong> ZAP Drops has advanced anti-bot
              mechanisms, meaning the reward pools are distributed to real
              people, not computers.
            </P>
          </ArticleContentBox>
          <ArticleContentBox>
            <H3 fw="semibold">How it Works</H3>
            <P c="text-secondary">
              <Box g={10}>
                <Lock01 color="white" />
                Projects lock up a certain reward for each Chapter in their
                airdrop.
              </Box>
            </P>
            <P c="text-secondary">
              <Box g={10}>
                <UserUp02 color="white" />
                Complete missions and level up, 50% of XP from the past chapter
                carries over to the new one
              </Box>
            </P>
            <P c="text-secondary">
              <Box g={10}>
                <Gift01 color="white" />
                At the end of the chapter a snapshot of the leaderboard is taken
                and users can redeem their reward
              </Box>
            </P>
          </ArticleContentBox>
          <DisclaimerBox>
            <DisclaimerTitle>Disclaimer</DisclaimerTitle>
            <DisclaimerText>
              Tokens available on this platform are not supported by ZAP. ZAP is
              not an investment service; tokens can lose significant value at
              any moment. By using ZAP, you accept all associated risks and
              agree to our{' '}
              <a
                href="https://docs.zap.tech/zaponchain/other/terms-and-conditions"
                target="_blank"
                rel="noreferrer"
              >
                Terms and Conditions
              </a>
              .
            </DisclaimerText>
          </DisclaimerBox>
          <Box g={10} ac fw>
            <ThemedLink to={routes.drops.index} $styleType="primary">
              Explore Drops
            </ThemedLink>
            <ThemedAnchor
              $styleType="tertiary"
              p="11px 20px 11px 16px"
              href="https://discord.gg/zaponchain"
            >
              <img
                src="/supported-socials/discord.svg"
                alt="ZAP Discord"
                height="20px"
                width="20px"
                style={{ borderRadius: '50%' }}
              />
              Discord
            </ThemedAnchor>
            <ThemedAnchor
              $styleType="tertiary"
              p="11px 20px 11px 16px"
              href="https://x.com/zaponchain"
            >
              <img
                src="/supported-socials/twitter.svg"
                alt="ZAP X"
                height="20px"
                width="20px"
                style={{ borderRadius: '50%' }}
              />
              X
            </ThemedAnchor>
          </Box>
        </>
      }
    />
  )
}

export default ZapDropsArticle
